import { render, staticRenderFns } from "./SPIFFinanicalReport.vue?vue&type=template&id=995596f4"
import script from "./SPIFFinanicalReport.vue?vue&type=script&lang=js"
export * from "./SPIFFinanicalReport.vue?vue&type=script&lang=js"
import style0 from "./SPIFFinanicalReport.vue?vue&type=style&index=0&id=995596f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports